import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Philosophy } from './components/Philosophy';
import { CurrentDeals } from './components/CurrentDeals';
import { CompletedDeals } from './components/CompletedDeals';
import { DealReport } from './components/DealReport';
import { HowItWorks } from './components/HowItWorks';
import { DealAlerts } from './components/DealAlerts';
import { About } from './components/About';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <Philosophy data-id="element-3" />
      <CurrentDeals data-id="element-4" />
      <CompletedDeals data-id="element-5" />
      <DealReport data-id="element-6" />
      <HowItWorks data-id="element-7" />
      <DealAlerts data-id="element-8" />
      <About data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}